import { OrganizedTimersEvent } from "@/types";
import {
  Dispatch,
  MutableRefObject,
  RefObject,
  SetStateAction,
  useEffect,
} from "react";

const useOutsideClick = (
  rowRef: RefObject<HTMLDivElement>,
  createAssigneeOpen: MutableRefObject<boolean>,
  createDateTimeStartOpen: MutableRefObject<boolean>,
  createDateTimeEndOpen: MutableRefObject<boolean>,
  saveAllowed: MutableRefObject<boolean>,
  editedTimerRef: MutableRefObject<OrganizedTimersEvent | null>,
  handleSave: (editedTimer: OrganizedTimersEvent) => Promise<void>,
  setIsEditing: Dispatch<SetStateAction<boolean>>
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      console.log("handleClickOutside");
      // Do not close if assigning a user
      if (createAssigneeOpen.current === true) {
        return;
      }

      // Do not close if creating a start date
      if (createDateTimeStartOpen.current === true) {
        return;
      }

      // Do not close if creating an end date
      if (createDateTimeEndOpen.current === true) {
        return;
      }

      // Save the task if allowed
      if (saveAllowed.current === true && editedTimerRef.current) {
        console.log("calling handleSave");
        handleSave(editedTimerRef.current);
        return;
      }

      // Close editing if clicked outside
      if (rowRef.current && !rowRef.current.contains(event.target as Node)) {
        setIsEditing(false);
        rowRef.current.style.outline = "";
      }

      saveAllowed.current = false;
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [
    setIsEditing,
    handleSave,
    createAssigneeOpen,
    createDateTimeStartOpen,
    createDateTimeEndOpen,
    saveAllowed,
    editedTimerRef,
    rowRef,
  ]);
};

export default useOutsideClick;
